import { UPLOAD_INTAKE_FORM_HEADSHOT } from 'modules/dashboard/store/constants';

export const uploadHeadshot = (file) => ({
  type: UPLOAD_INTAKE_FORM_HEADSHOT,
  payload: {
    file,
  },
});
